import { Trans } from '@lingui/react/macro'
import { t } from '@lingui/core/macro'
import { Link } from 'react-router-dom'
import { BaseErrorPage } from './BaseErrorPage'
import { useEffect } from 'react'

export function ErrorPageNotFound({ resetError }: { resetError?: () => void }) {
  useEffect(() => {
    return () => {
      if (resetError) {
        resetError()
      }
    }
  }, [resetError])

  return (
    <BaseErrorPage reportError={undefined} title={t`Page not found`}>
      <p>
        <Trans>
          Try to go back to the homepage, or have a look in the navigation menu
          below. We are sorry for the inconvenience, we hope you find what you
          are looking for.
        </Trans>
      </p>
      <p>
        <Link to="/" className="link" replace reloadDocument>
          <Trans>Click here to go back to the homepage.</Trans>
        </Link>
      </p>
    </BaseErrorPage>
  )
}
